var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"category",attrs:{"to":_vm.computedUrl,"title":_vm.category.title}},[_c('img',{attrs:{"src":_vm.imageUrl,"alt":_vm.category.title}}),_c('h3',[_vm._v(_vm._s(_vm.category.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }